import dadesCSV from './assets/renda.csv'

const rendaPerCusec = ['match', ['get', 'CUSEC']]
export const dadesPerCusec = new Map()
export const rendaColors = [
	'#e6a0a0',
	'#edad94',
	'#f4c990',
	'#f1e3ac',
	'#c8d1bd',
	'#88adb0',
	'#4f829a',
	'#245777',
	'#002d53',
]
let min = Infinity
let max = -Infinity
for (const fila of dadesCSV) {
	const cusec = String(fila.CUSEC ?? '')
		.trim()
		.padStart(10, '0')
	const rendaText = String(fila['renda neta'] ?? '').trim()
	const renda = Number(rendaText)
	if (cusec.length === 10) {
		dadesPerCusec.set(cusec, fila)
	}
	if (cusec.length === 10 && rendaText !== '' && Number.isFinite(renda) && renda > 0) {
		rendaPerCusec.push(cusec, renda)
		min = Math.min(min, renda)
		max = Math.max(max, renda)
	}
}
rendaPerCusec.push(-1)

export const rendaMin = min
export const rendaMax = max

const rendaColorStops = rendaColors.flatMap((color, index) => [
	rendaMin + ((rendaMax - rendaMin) * index) / (rendaColors.length - 1),
	color,
])

export const rendaSource = {
	id: 'seccions-renda',
	type: 'vector',
	url: 'mapbox://diariara.eecysw5unkuo',
}

export const rendaBeforeId = 'land-structure-line'

export const rendaLayer = {
	id: 'renda-seccions',
	type: 'fill',
	source: rendaSource.id,
	'source-layer': 'tc3oq8tjei90ksoz7pjv',
	paint: {
		'fill-color': [
			'let',
			'renda',
			rendaPerCusec,
			[
				'case',
				['<', ['var', 'renda'], 0],
				'#dfe3e6',
				['interpolate', ['linear'], ['var', 'renda'], ...rendaColorStops],
			],
		],
		'fill-opacity': 0.85,
	},
}

export const rendaOutlineLayer = {
	id: 'renda-seccions-contorn',
	type: 'line',
	source: rendaSource.id,
	'source-layer': 'tc3oq8tjei90ksoz7pjv',
	paint: {
		'line-color': '#ffffff',
		'line-width': 0.5,
	},
}
